import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './styles/reactSelect.css';
import './styles/agGrid.css';
import './styles/mantineCalendar.css';
import 'dayjs/locale/pt';
import { ErrorBoundary } from './components/ErrorBoundary';
import {
  installChunkLoadDiagnostics,
  installGlobalErrorDiagnostics,
} from './lib/frontendDiagnostics';

installChunkLoadDiagnostics();
installGlobalErrorDiagnostics();

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);
